import { useGlobalDrawer } from "@/core/context/GlobalDrawerProvider"
import { GlobalID } from "@/relay/RelayTypes"
import ProfileAvatarStack, {
  CountVariants,
  ProfileAvatarStackProps,
} from "@/user/common/avatar-stack/ProfileAvatarStack"
import OpenProfilePopoverButton from "@/user/common/profile-popover/OpenProfilePopoverButton"

type ChatChannelAvatarStackProps = Pick<
  ProfileAvatarStackProps,
  "users" | "totalUsers" | "avatarSize" | "className"
> & {
  channelId?: GlobalID
  countVariant?: CountVariants
  listOnly?: boolean
}

function ChatChannelAvatarStack({
  users,
  totalUsers,
  avatarSize = 24,
  className,
  channelId,
  countVariant,
  listOnly,
}: ChatChannelAvatarStackProps) {
  const singleUserId = users.length === 1 && users[0]?.id
  const drawer = useGlobalDrawer("chatChannelSettings")

  return (
    <>
      {singleUserId && !listOnly ? (
        <OpenProfilePopoverButton stopPropagation userId={singleUserId}>
          {(profileButtonProps) => (
            <ProfileAvatarStack
              testid={"ChatChannelAvatarStack"}
              users={users}
              className={className}
              avatarSize={avatarSize}
              onClick={profileButtonProps.onClick}
              viewUserTooltip={{
                content: `${users[0].firstName} ${users[0].lastName}`,
                dataPrivate: true,
              }}
              stackSize={1}
            />
          )}
        </OpenProfilePopoverButton>
      ) : channelId ? (
        <ProfileAvatarStack
          testid={"ChatChannelAvatarStack"}
          users={users}
          totalUsers={totalUsers}
          className={className}
          avatarSize={avatarSize}
          onClick={openChatChannelMembersTab}
          countVariant={countVariant}
        />
      ) : null}
    </>
  )

  function openChatChannelMembersTab() {
    drawer.open({
      chatChannelId: channelId,
      chatChannelSettingsTab: "members",
    })
  }
}

export default ChatChannelAvatarStack
